import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { ReportJobStatusEnum } from '../enums/report-job-status.enum';

/**
 * Report job DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.REPORT_JOB)
export class ReportJobSearchDto extends BaseSearchDto {
	reportId!: number;
	reportName!: string;
	queuedAt!: Date;
	completedAt?: Date;
	status!: ReportJobStatusEnum;

	displayValue(): string | null {
		return `${this.reportName}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string | null {
		return '';
	}
}
